import './legacy-browser';
import React from 'react';
import ReactDOM from 'react-dom/client';
import CourseApp from './CourseApp';
import CoursePreview from './CoursePreview';
import CourseAppMobile from './CourseAppMobile';
import manager from './Manager';
// import reportWebVitals from './reportWebVitals';

import './index.css';
class TBCourse {
    constructor(options) {
        const defaultOptions = {
            root: 'root',
            settings: {}
        }
        this.options = { ...defaultOptions, ...options };

        this.manager = manager;
    }

    setData(data) {
        data.forEach((item) => {
            let templateType = item.type;
            let template = this.manager.getTemplate(templateType);
            let slide = this.manager.createSlide(template, item.data ?? {}, item.id, item.duration, item.name);
            this.manager.slides.push(slide);
        });

        //we check for start and end template
        let startSlide = this.manager.slides.find((item) => {
            return item.template.type() === this.manager.templateManager.startTemplate.type();
        });

        // update slide can empty, so disable add startSlide as default, add default by php
        // if (!startSlide) {
        //     startSlide = this.manager.createSlide(this.manager.templateManager.startTemplate);
        //     let array = this.manager.slides.slice();
        //     array.unshift(startSlide)
        //     this.manager.slides = array;

        // }
        let finishSlide = this.manager.slides.find((item) => {
            return item.template.type() === this.manager.templateManager.finishTemplate.type();
        });

        // update slide can empty, so disable add finishSlide as default, add default by php
        // if (!finishSlide) {
        //     finishSlide = this.manager.createSlide(this.manager.templateManager.finishTemplate);
        //     this.manager.slides.push(finishSlide);
        // }
    }
    setProgressData(progressData) {
        this.manager.progressData = progressData;
    }
    render() {
        this.manager.inEditor = true;
        this.manager.setOptions(this.options);
        const root = ReactDOM.createRoot(document.getElementById(this.options.root));
        root.render(
            <React.StrictMode>
                <CourseApp />
            </React.StrictMode>
        );
    }
    renderMobile() {
        this.manager.inEditor = true;
        this.manager.setOptions(this.options);
        const root = ReactDOM.createRoot(document.getElementById(this.options.root));
        root.render(
            <React.StrictMode>
                <CourseAppMobile />
            </React.StrictMode>
        );
    }
    preview() {
        this.manager.setOptions(this.options);
        const root = ReactDOM.createRoot(document.getElementById(this.options.root));
        root.render(
            <React.StrictMode>
                <CoursePreview />
            </React.StrictMode>
        );
    }
}


window.TBCourse = TBCourse;
// Membuat event baru dengan data tambahan
const tbCourseLoadedEvent = new CustomEvent('tbcourse:loaded', {
    bubbles: true,
    cancelable: true,
    detail: {}
});
// Mendispatch event ke objek window
window.dispatchEvent(tbCourseLoadedEvent);
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
